import MagazineTag from '@uikit/components/MagazineTag/MagazineTag';
import Section from '@uikit/components/Section/Section';
import { SocialMediaItem } from '@uikit/components/SocialMediaList/interfaces';
import SocialMediaList from '@uikit/components/SocialMediaList/SocialMediaList';
import MagazineArticleDate from '../MagazineArticleDate/MagazineArticleDate';
import type { MagazineArticleFooterProps } from './interfaces';
import styles from './MagazineArticleFooter.module.scss';

const MagazineArticleFooter = ({
  date,
  tags,
  title,
  articlePagePath,
  additionalInfo,
  className,
}: MagazineArticleFooterProps) => {
  const ARTICLE_DETAIL_FOOTER_SOCIAL_MEDIA_LIST: SocialMediaItem[] = [
    {
      icon: 'user/mail',
      url:
        'mailto:?subject=' + title + '&body=' + title + ' ' + articlePagePath,
      title: 'Artikel über Mail teilen',
    },
    {
      icon: 'action/facebook',
      url: 'http://www.facebook.com/share.php?u=' + articlePagePath,
      title: 'Artikel über Facebook teilen',
    },
    {
      icon: 'action/twitter',
      url: encodeURI(
        'https://twitter.com/intent/tweet?text=' + title + ' ' + articlePagePath
      ),
      title: 'Artikel über Twitter teilen',
    },
  ];

  return (
    <Section className={className}>
      <div className={styles.base}>
        <MagazineArticleDate date={date} />
        <div className={styles.innerWrapper}>
          {tags && (
            <div className={styles.tagWrapper}>
              {tags.slice(0, 3).map((tag) => (
                <MagazineTag
                  key={tag}
                  variant="category"
                  size="small"
                  title={tag}
                  className={styles.tag}
                />
              ))}
            </div>
          )}
          <SocialMediaList
            className={styles.social}
            items={ARTICLE_DETAIL_FOOTER_SOCIAL_MEDIA_LIST}
          />
        </div>
        {additionalInfo && <p className={styles.info}>{additionalInfo}</p>}
      </div>
    </Section>
  );
};

export default MagazineArticleFooter;
